import { render } from "./TenantConfigurationUpdate.vue?vue&type=template&id=2bdeeb48&scoped=true"
import script from "./TenantConfigurationUpdate.vue?vue&type=script&lang=js"
export * from "./TenantConfigurationUpdate.vue?vue&type=script&lang=js"

import "./TenantConfigurationUpdate.vue?vue&type=style&index=0&id=2bdeeb48&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2bdeeb48"]])

export default __exports__